// extracted by mini-css-extract-plugin
export default {"event_schedule":"styles_event_schedule__IH4X7","icon_wrapper":"styles_icon_wrapper__BLqGL","calendar_icon":"styles_calendar_icon__ZsI4-"};